interface WebsiteSchemaProps {
  name: string;
  url: string;
  description: string;
  inLanguage?: string;
  logo?: string;
  sameAs?: string[];
}

export const generateWebsiteSchema = ({
  name,
  url,
  description,
  inLanguage = 'en-US',
  logo,
  sameAs = [],
}: WebsiteSchemaProps) => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name,
  url,
  description,
  inLanguage,
  ...(logo && { logo }),
  ...(sameAs.length > 0 && { sameAs }),
});

interface WebPageSchemaProps extends WebsiteSchemaProps {
  headline: string;
  datePublished?: string;
  dateModified?: string;
  author?: {
    '@type': string;
    name: string;
    url?: string;
  };
  publisher?: {
    '@type': string;
    name: string;
    logo?: {
      '@type': string;
      url: string;
      width?: number;
      height?: number;
    };
  };
  image?: string | string[];
}

export const generateWebPageSchema = ({
  name,
  url,
  description,
  headline,
  inLanguage = 'en-US',
  datePublished,
  dateModified = new Date().toISOString(),
  author,
  publisher,
  image,
}: WebPageSchemaProps) => ({
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name,
  url,
  description,
  headline,
  inLanguage,
  ...(datePublished && { datePublished }),
  dateModified,
  ...(author && { author }),
  ...(publisher && { publisher }),
  ...(image && { image }),
});

export const generateBreadcrumbSchema = (items: Array<{ name: string; item: string }>) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.item,
  })),
});
